import React, { useContext, useState } from "react";

interface IAuth {
  token: string | null;
  logout: Function;
  login: (token: string) => void;
}

const AuthContext = React.createContext<IAuth>({} as IAuth);

type AuthProviderProps = {
  children: React.ReactNode;
};

export const AuthProvider = ({ children }: AuthProviderProps): JSX.Element => {
  const [user, setUser] = useState<string | null>(null);

  const logout = () => {
    setUser(null);
  };

  const login = (token: string) => {
    setUser(token);
  };

  return (
    <AuthContext.Provider
      value={{
        token: user,
        logout,
        login,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = (): IAuth => {
  return useContext(AuthContext);
};
